import * as React from 'react'
import { Description, Title } from './styled'
import Grid from '@mui/material/Grid'

type Props = {
  title: string
  description: string
}

export function ListItemTextContents(props: Props) {
  const { title, description } = props

  return (
    <Grid container>
      <Grid item xs={4}>
        <Title>{title} -</Title>
      </Grid>
      <Grid item xs={8}>
        <Description>{description}</Description>
      </Grid>
    </Grid>
  )
}
